<template>
  <div :class="wrapClass" :aria-label="priceLabel">
    <template v-if="hasDecimal">
      <span v-if="currencyPrepend" class="bp-add-on-amount__main bp-add-on-amount__unit" aria-hidden="true">
        {{ currency }}
      </span>
      <span class="bp-add-on-amount__main" aria-hidden="true">{{ integerPart }}</span>
      <span class="bp-add-on-amount__ss" aria-hidden="true">
        {{ `${showDot ? decimalSeperator : ''}${decimalPart}` }}
      </span>
      <span v-if="!currencyPrepend" class="bp-add-on-amount__main" style="margin-left: 4px" aria-hidden="true">
        {{ currency }}
      </span>
    </template>
    <template v-else>
      <span class="bp-add-on-amount__main" aria-hidden="true">{{ price }}</span>
    </template>
  </div>
</template>

<script>

import Cookies from 'js-cookie'

const separatorConfig = {
  'en-US': { decimal: '.', commaStyle: ',', place: 'begin', space: false },
  'en-GB': { decimal: '.', commaStyle: ',', place: 'begin', space: false },
  'zh-CN': { decimal: '.', commaStyle: ',', place: 'end', space: true, specialSymbol: true },
  'es-ES': { decimal: ',', commaStyle: '.', place: 'end', space: true },
  'fr-FR': { decimal: ',', commaStyle: ' ', place: 'end', space: true },
  'jp-JP': { decimal: '.', commaStyle: ',', place: 'begin', space: true },
  'de-DE': { decimal: ',', commaStyle: '.', place: 'end', space: true },
  'pt-PT': { decimal: ',', commaStyle: '.', place: 'begin', space: true },
  'ru-RU': { decimal: ',', commaStyle: ' ', place: 'end', space: true, specialSymbol: true },
  'zh-TW': { decimal: '.', commaStyle: ',', place: 'end', space: true, specialSymbol: true },
  'ko-KO': { decimal: '.', commaStyle: ',', place: 'begin', space: false },
  'it-IT': { decimal: ',', commaStyle: '.', place: 'begin', space: true },
  'vi-VN': { decimal: ',', commaStyle: '.', place: 'begin', space: true }
}


const getDecimalSeparatorConfig = (language) => {
  return separatorConfig[language] || { decimal: '.', commaStyle: ',', place: 'begin', space: false }
}

const USER_LANG = Cookies.get('_zm_lang') || 'en-US'

const UserSeparator = getDecimalSeparatorConfig(USER_LANG)

export default {
  props: {
    // The price may like:
    // $14.99
    price: {
      type: String,
      required: true
    },
    fixedDigit: {
      type: Number,
      default: 2
    },
    showDot: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    wrapClass() {
      return {
        'bp-add-on-amount': true,
        'bp-add-on-super-script': this.hasDecimal
      }
    },
    hasDecimal() {
      return this.price.indexOf(this.decimalSeperator) > 0
    },
    decimalSeperator() {
      return UserSeparator.decimal
    },
    decimalPart() {
      let result = (this.hasDecimal ? this.price.slice(this.price.indexOf(this.decimalSeperator) + 1) : '')
        .replace(this.currency, '')
        .trim()
      if (result.length < this.fixedDigit) {
        result += new Array(this.fixedDigit - result.length + 1).join('0')
      }
      return result
    },
    integerPart() {
      return this.hasDecimal
        ? this.price.slice(0, this.price.indexOf(this.decimalSeperator)).replace(this.currency, '').trim()
        : ''
    },
    amount() {
      const amountReg = /[\d,]+(\.\d+)/
      const matchResult = this.price.match(amountReg)
      if (matchResult) {
        return matchResult[0]
      } else {
        return this.additionalFormatCurrency(this.price)
      }
    },
    currency() {
      return this.price
        .replace(this.amount, '')
        .replace(/[.,\d]/g, '')
        .trim()
    },
    currencyPrepend() {
      return this.price.indexOf(this.currency) === 0
    },
    priceLabel() {
      if (this.hasDecimal) {
        const price = `${this.integerPart}.${this.decimalPart}`
        if (this.currencyPrepend) {
          return this.currency + price
        } else {
          return price + this.currency
        }
      } else {
        return this.price
      }
    }
  },
  methods: {
    additionalFormatCurrency(price) {
      const amountReg = /[\d\s]+[.,]\d+/
      const matchResult = price.match(amountReg)
      if (matchResult) {
        return matchResult[0]
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$text-color: #00053d;
.bp-add-on-amount {
  display: flex;
  &__main {
    font-size: 20px;
    font-weight: 700;
    color: $text-color;
  }
  &__ss {
    font-size: 12px;
    font-weight: 700;
    color: $text-color;
    margin-left: 1px;
  }
}
</style>
